import { NavigationEnd, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { moduleHeaderList } from '../utils/header-list';

@Injectable( {
  providedIn: 'root'
} )
export class HeaderService {
  router$: Subscription;
  moduleHeaderItem: BehaviorSubject<any> = new BehaviorSubject( [] );
  sideBarState: BehaviorSubject<any> = new BehaviorSubject( false );

  constructor( private router: Router ) {
    this.router$ = this.router.events.subscribe( event => {

      if( event instanceof NavigationEnd ) {
        const headerItem = moduleHeaderList.filter( item => {
          return item.path === '/pages/' + event.urlAfterRedirects.split( '/' )[2];
        } );
        this.moduleHeaderItem.next( headerItem[0] );
      }

    } );
  }
}
